"use strict";

exports.__esModule = true;
exports.getUiLayout = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ = require("./");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const isExpanded = props => {
  const id = props.id,
        name = props.name,
        uiOptions = props.uiOptions,
        registry = props.registry;
  const collapsible = uiOptions.collapsible,
        editable = uiOptions.editable,
        expanded = uiOptions.expanded;
  const formContext = registry.formContext;
  const currentId = formContext.currentId;

  if (editable && expanded && !currentId) {
    return true;
  } else if (editable && currentId && currentId.startsWith(id)) {
    return true;
  } else if (editable) {
    return false;
  } else if (collapsible && expanded && !currentId) {
    return true;
  } else if (collapsible && currentId && currentId.startsWith(id)) {
    return true;
  } else if (collapsible) {
    return false;
  }

  return;
};

const isEditing = props => {
  const id = props.id,
        uiOptions = props.uiOptions,
        registry = props.registry;
  const editable = uiOptions.editable,
        expanded = uiOptions.expanded;
  const formContext = registry.formContext;
  const currentId = formContext.currentId;

  if (editable && expanded) {
    return true;
  } else if (editable && currentId && currentId.startsWith(id)) {
    return true;
  }

  return false;
};

const getUiLayout = (_ref) => {
  let _ref$schema = _ref.schema,
      schema = _ref$schema === void 0 ? {} : _ref$schema,
      props = _objectWithoutPropertiesLoose(_ref, ["schema"]);

  const id = props.id,
        idPrefix = props.idPrefix,
        name = props.name,
        idSchema = props.idSchema,
        formData = props.formData,
        uiSchema = props.uiSchema,
        registry = props.registry;
  const uiOptions = (0, _.getUiOptions)(uiSchema); // layout

  let layout = uiOptions.layout,
      widget = uiOptions.widget; // title, description, summary, help

  let title = uiOptions.title,
      description = uiOptions.description,
      help = uiOptions.help;
  title = title && typeof title === "string" && title || schema.title || name || formData && formData.title && typeof formData.title === "string" && formData.title || undefined;
  description = description && typeof description === "string" && description || undefined;
  help = description && typeof description === "string" && description || uiOptions.help || undefined; // disabled, readonly, autofocus

  const disabled = Boolean(props.disabled || uiSchema["ui:disabled"]);
  const readonly = Boolean(props.readonly || uiSchema["ui:readonly"]);
  const autofocus = Boolean(props.autofocus || uiSchema["ui:autofocus"]); // editable, editing

  const editable = uiOptions.editable && Boolean(uiOptions.editable) || false;
  const editing = isEditing(_extends({}, props, {
    uiOptions
  })); // collapsible + expanded

  const collapsible = uiOptions.collapsible && Boolean(uiOptions.collapsible) || false;
  const expanded = isExpanded(_extends({}, props, {
    uiOptions
  }));
  /*
  
  let expanded;
  
  if (uiOptions.expanded === false) {
      expanded = Boolean(uiOptions.expanded)
  } else if (uiOptions.expanded) {
      expanded = Boolean(uiOptions.expanded)
  } else {
      expanded = isExpanded(props)
  }
  */
  // hideable, deletable, restorable

  let hideable = Boolean(uiOptions.hideable);
  let deletable = Boolean(uiOptions.deletable);
  let restorable = Boolean(uiOptions.restorable); // orderable

  let orderable;

  if (uiOptions.orderable === false) {
    orderable = false;
  } else {
    orderable = true;
  } // addable + removable


  let addable, removable;

  if (uiOptions.addable === false) {
    addable = false;
  } else {
    addable = Boolean(uiOptions.addable);
  }

  if (uiOptions.removable === false) {
    removable = false;
  } else {
    removable = Boolean(uiOptions.removable) || props.isArrayItem && props.hasRemove;
  } // default array layout


  if (!layout && schema.type === "array") {
    layout = "array";
  }

  if (!layout && schema.type === "object") {
    layout = "object";
  } // simple layouts


  if (!layout && (schema.type === "string" || schema.type === "number" || schema.type === "integer" || schema.type === "boolean")) {
    layout = "field";
  } // show label?


  let label;

  if (uiOptions.label === false) {
    label = false;
  } else if (schema.type === "object") {
    label = schema.title && true || uiOptions.title && true || false;
  } else if (schema.type === "boolean" && (widget === "select" || widget === "radio")) {
    label = true;
  } else if (schema.type === "boolean") {
    label = false;
  } else {
    label = true;
  } // show header?


  let header;

  if (!label) {
    header = false;
  } // show footer?


  let footer;

  if (schema.type == "object" && !uiOptions.buttons) {
    footer = false;
  }

  return _extends({}, uiOptions, {
    name: name,
    id: id,
    idPrefix: idPrefix,
    header: header,
    footer: footer,
    collapsible: collapsible,
    expanded: expanded,
    editable: editable,
    editing: editing,
    addable: addable,
    removable: removable,
    hideable: hideable,
    deletable: deletable,
    restorable: restorable,
    disabled: disabled,
    readonly: readonly,
    autofocus: autofocus,
    label: label,
    title: title || undefined,
    description: description,
    help: help,
    layout: layout
  });
};

exports.getUiLayout = getUiLayout;